module.exports = __webpack_public_path__ + "img/process-small4.75113689.png";